// extracted by mini-css-extract-plugin
module.exports = {"newsByCategoryContainer":"NewsByTag_newsByCategoryContainer__1Lt60","newsByCategory":"NewsByTag_newsByCategory__2BJDw"};